// extracted by mini-css-extract-plugin
export default {"valuesWrapper":"SettingsValues_valuesWrapper__1ASwz","maxValueWrapper":"SettingsValues_maxValueWrapper__xlMmC","startValueWrapper":"SettingsValues_startValueWrapper__ENd6d"};